import { notFound } from 'next/navigation'

import { SUPPORTED_LANGUAGES } from './constant'
import { SUPPORTED_PORTS, TSupportedPort } from '../constants'

import { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'

export const getNameInitials = (name?: string) => {
  return name
    ?.split(' ')
    .map((word) => word[0])
    .join('')
}

export const getIsHomepage = (pathname?: string | null) => {
  return (
    SUPPORTED_LANGUAGES.map((locale) => {
      return pathname === `/${locale}`
    }).some((value) => value) || pathname === '/'
  )
}

export const formatSocialMetric = (metric: number) => {
  if (metric > 1000) {
    return `${(metric / 1000).toFixed(1)}K`
  }
  if (metric > 1000000) {
    return `${(metric / 1000000).toFixed(1)}M`
  }
  return metric
}

export const distanceKm = (aLat: number, aLon: number, bLat: number, bLon: number) => {
  const toRad = (x: number) => (x * Math.PI) / 180
  const R = 6371
  const dLat = toRad(bLat - aLat)
  const dLon = toRad(bLon - aLon)
  const la1 = toRad(aLat),
    la2 = toRad(bLat)
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(la1) * Math.cos(la2) * Math.sin(dLon / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(h))
}

export const emailIsValid = (email: string) => {
  // Basic email validation; keep lightweight
  return /^\S+@\S+\.\S+$/.test(email)
}

export function sanitizeDomainPlausible(url: string) {
  return url
    .replace(/^https?:\/\//, '') // remove http:// or https://
    .replace(/^www\./, '') // remove www.
}

export const get50Characters = (text: string) => {
  return text.length > 50 ? text.slice(0, 50) + '...' : text
}

export const getVesselImageUrl = (vessel: TVesselJourneyResponse) => {
  if (process.env.NEXT_PUBLIC_BASE_PATH) {
    return `${process.env.NEXT_PUBLIC_BASE_PATH}/api/image/vessels/${vessel.ship.category}/${vessel.ship.deadWeightTonnage}`
  }
  return `/api/image/vessels/${vessel.ship.category}/${vessel.ship.deadWeightTonnage}`
}

export function assertSupportedPort(port: string): asserts port is TSupportedPort {
  if (!SUPPORTED_PORTS.includes(port as TSupportedPort)) {
    notFound()
  }
}

export function isValidDate(date: string) {
  return !Number.isNaN(Date.parse(date))
}
